export const ADMIN = "ADMIN";
export const APPNAME = "TCTUI";
export const COMPANYCODE = "TCT";
export const SOURCE = "UI";
export const PACKAGETYPECUSTOMIZED = "customized";
export const UPLOADIMAGES = "UploadImages";
export const NextYearsDDL = 5;
export const cultureFormat = "en-IN";

